<p-button
    [type]="type()"
    [label]="label()"
    [icon]="icon()"
    [iconPos]="iconPos()"
    [severity]="severity()"
    [size]="size()"
    [outlined]="outlined()"
    [text]="text()"
    [fluid]="fluid()"
    [loading]="loading()"
    [disabled]="disabled() || loading()"
    [ariaLabel]="ariaLabel()"
    [attr.data-testid]="testId()"
    (onClick)="clicked.emit($event)"
/>
